<!-- StepTableRoles.vue -->
<template>
  <div class="modal_main_table">
    <div class="modal_main_inputs_head">
      Lazarus AI автоматически выделил роли и участников процесса
    </div>
    
    <!-- Основная таблица -->
    <div class="modal_main_table_content">
      <div class="table_header">
        <div class="table_row">
          <div class="table_cell">Роль</div>
          <div class="table_cell">Стоимость часа (₽)</div>
          <div class="table_cell">Количество сотрудников</div>
          <div class="table_cell source-cell">Источник</div>
          <div class="table_cell action-cell"></div>
        </div>
      </div>

      <div class="table_body">
        <div class="table_row" v-for="(role, index) in roles" :key="index">
          <div class="table_cell">
            <span class="table_cell_input" contenteditable="true" @blur="updateRole(index, 'name', $event)">
              {{ role.name }}
            </span>
          </div>
          <div class="table_cell">
            <span class="table_cell_input" contenteditable="true" @blur="updateRole(index, 'cost', $event)">
              {{ role.cost }}
            </span>
          </div>
          <div class="table_cell">
            <span class="table_cell_input" contenteditable="true" @blur="updateRole(index, 'count', $event)">
              {{ role.count }}
            </span>
          </div>
          <div class="table_cell source-cell">
            <span class="table_cell_class">{{ role.source }}</span>
          </div>
          <div class="table_cell action-cell">
            <svg width="32" height="32" viewBox="0 0 48 46" fill="none" xmlns="http://www.w3.org/2000/svg" @click="deleteRole(index)" style="cursor: pointer;">
              <ellipse cx="24" cy="23" rx="24" ry="23" fill="#852020" />
              <path
                d="M17.25 16.6667V29.1222C17.25 30.3046 17.25 30.8953 17.4952 31.3469C17.711 31.7441 18.0549 32.0677 18.4783 32.2701C18.9591 32.5 19.5889 32.5 20.8465 32.5H27.1535C28.4111 32.5 29.04 32.5 29.5208 32.2701C29.9442 32.0677 30.2893 31.7441 30.505 31.3469C30.75 30.8958 30.75 30.3055 30.75 29.1255V16.6667M17.25 16.6667H19.5M17.25 16.6667H15M19.5 16.6667H28.5M19.5 16.6667C19.5 15.683 19.5 15.1914 19.6713 14.8035C19.8996 14.2862 20.3374 13.875 20.8887 13.6607C21.3022 13.5 21.8266 13.5 22.875 13.5H25.125C26.1734 13.5 26.6976 13.5 27.111 13.6607C27.6624 13.875 28.1003 14.2862 28.3286 14.8035C28.4999 15.1914 28.5 15.683 28.5 16.6667M28.5 16.6667H30.75M30.75 16.6667H33"
                stroke="#FE4F52" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
        </div>
      </div>
      
      <!-- Кнопка добавления новой строки -->
      <div class="table_add_row" @click="addNewRole">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 5V19M5 12H19" stroke="#8A75FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Добавить роль</span>
      </div>
    </div>
    
    <br>
    
    <!-- Блок с штатным расписанием -->
    <div class="modal_main_table_second_content">
      <div>
        <div class="modal_main_table_second_content_head">
          Оценка стоимости с привязкой к Штатному расписанию
        </div>
        <br>
        <div class="modal_main_table_second_content_text">
          Загрузите файл ШР для автоматического сопоставления ставок
        </div>
      </div>

      <div class="modal_main_table_second_content_tumbler" 
           @click="$emit('update:tumbler', !tumbler)"
           :class="{ modal_main_table_second_content_tumbler_active: tumbler }">
        <div class="modal_main_table_second_content_tumbler_circl"
             :class="{ modal_main_table_second_content_tumbler_circl_active: tumbler }"></div>
      </div>
    </div>
    
    <br>
    
    <!-- Блок загрузки штатного расписания -->
    <div class="modal_main_table_second_content_load_block" 
         :class="{ 'modal_main_table_second_content_load_block_hidden': !tumbler }">
      
      <StepUploadFile 
      :drag-over="dragOver"
      :file-data="fileData"
      :title="'Штатное расписание'"
      :subtitle="'Выберите файл штатного расписания или перетащите сюда'"
      :show-staff-icon="true"
      :show-continue="false"
      :upload-target="uploadTarget"
      @update:drag-over="$emit('update:drag-over', $event)"
      @update:file-data="$emit('update:file-data', $event)"
      @file-upload="$emit('file-upload', $event)"
      @drag-over-event="$emit('drag-over-event', $event)"
      @drag-leave-event="$emit('drag-leave-event', $event)"
      @drop-event="$emit('drop-event', $event)"
      />
      
      <br>
      
      <!-- Таблица сопоставления с редактируемыми полями и стрелками -->
      <div v-if="hasFile" class="mapping-table-container">
           <!-- Лоадер -->
        <div v-if="isLoadingStaffing" class="staffing-loader">
          <div class="spinner"></div>
          <span>Загрузка штатного расписания...</span>
        </div>
        <div v-else class="modal_main_table_content">
          <div class="table_header">
            <div class="table_row_v2">
              <div class="table_cell">Роль</div>
              <div class="table_cell">Должность из ШР</div>
              <div class="table_cell">Стоимость часа</div>
              <div class="table_cell">Количество сотрудников</div>
              <div class="table_cell action-cell">Перенести</div>
            </div>
          </div>
          <div class="table_body">
            <div class="table_row_v2" v-for="(mapping, index) in roleMappings" :key="index">
              <div class="table_cell">
                <span class="table_cell_input" contenteditable="true" @blur="updateMapping(index, 'role', $event)">
                  {{ mapping.role }}
                </span>
              </div>
              <div class="table_cell">
                <span class="table_cell_input" contenteditable="true" @blur="updateMapping(index, 'position', $event)">
                  {{ mapping.position }}
                </span>
              </div>
              <div class="table_cell">
                <span class="table_cell_input" contenteditable="true" @blur="updateMapping(index, 'cost', $event)">
                  {{ mapping.cost }}
                </span>
              </div>
              <div class="table_cell">
                <span class="table_cell_input" contenteditable="true" @blur="updateMapping(index, 'count', $event)">
                  {{ mapping.count }}
                </span>
              </div>
              <div class="table_cell action-cell">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" 
                     @click="moveToMainTable(index)" style="cursor: pointer;" class="arrow-up-icon">
                  <path d="M12 19V5M12 5L5 12M12 5L19 12" stroke="#8A75FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Кнопка добавления новой строки в таблице сопоставления -->
        <div class="table_add_row" @click="addNewMapping">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5V19M5 12H19" stroke="#8A75FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>Добавить соответствие</span>
        </div>
      </div>
      
      <!-- Добавляем отступ снизу для блока -->
      <div v-if="hasFile" class="mapping-table-bottom-spacing"></div>
    </div>
    
    <br>
    
    <!-- Кнопка продолжения -->
    <div class="modal_main_load_content_btn" @click="continueClick"
        style="cursor: pointer; width: 100%; max-width: none;">
      <span>Продолжить</span>
    </div>
  </div>
</template>

<script>
import StepUploadFile from './StepUploadFile.vue'

export default {
  name: 'StepTableRoles',
  components: {
    StepUploadFile
  },
  props: {
    isLoadingStaffing: {  // добавляем проп для состояния загрузки
      type: Boolean,
      default: false
    },
    tumbler: {
      type: Boolean,
      default: false
    },
    dragOver: {
      type: Boolean,
      default: false
    },
    fileData: {
      type: Object,
      default: () => ({})
    },
    uploadTarget: {
      type: [String, Number],
      default: '4'
    },
    roles: {
      type: Array,
      default: () => []
    },
    roleMappings: {
      type: Array,
      default: () => []
    }
  },
  emits: [
    'update:tumbler', 
    'update:drag-over', 
    'update:file-data', 
    'file-upload',
    'drag-over-event',
    'drag-leave-event',
    'drop-event',
    'update:roles',
    'update:roleMappings',
    'update-role',
    'delete-role',
    'update:mapping',
    'add-role',
    'add-mapping',
    'move-to-main',
    'save-roles',
    'continue'
  ],
  computed: {
    hasFile() {
      return this.fileData && Object.keys(this.fileData).length > 0
    }
  },
  methods: {
    continueClick() {
    // Если есть сохраненные роли, отправляем их
        if (this.roles && this.roles.length > 0) {
          this.$emit('save-roles')
        } else {
          // Если ролей нет, просто переходим дальше
          this.$emit('continue')
        }
      },
    // Методы для основной таблицы
    updateRole(index, field, event) {
      const newValue = event.target.innerText
      const updatedRoles = [...this.roles]
      updatedRoles[index] = {
        ...updatedRoles[index],
        [field]: newValue
      }
      this.$emit('update:roles', updatedRoles)
      this.$emit('update-role', { index, field, value: newValue })
    },
    
    deleteRole(index) {
      const updatedRoles = this.roles.filter((_, i) => i !== index)
      this.$emit('update:roles', updatedRoles)
      this.$emit('delete-role', index)
    },
    
    addNewRole() {
      const newRole = {
        name: 'Новая роль',
        cost: '0',
        count: '1',
        source: 'Добавлено вручную'
      }
      const updatedRoles = [...this.roles, newRole]
      this.$emit('update:roles', updatedRoles)
      this.$emit('add-role', newRole)
    },
    
    // Методы для таблицы сопоставления
    updateMapping(index, field, event) {
      const newValue = event.target.innerText
      const updatedMappings = [...this.roleMappings]
      updatedMappings[index] = {
        ...updatedMappings[index],
        [field]: newValue
      }
      this.$emit('update:roleMappings', updatedMappings)
      this.$emit('update:mapping', { index, field, value: newValue })
    },
    
    addNewMapping() {
      const newMapping = {
        role: 'Новая роль',
        position: 'Новая должность',
        cost: '0',
        count: '1'
      }
      const updatedMappings = [...this.roleMappings, newMapping]
      this.$emit('update:roleMappings', updatedMappings)
      this.$emit('add-mapping', newMapping)
    },
    
    moveToMainTable(index) {
      const mappingToMove = this.roleMappings[index]
      
      // Создаем новую роль из маппинга
      const newRole = {
        name: mappingToMove.role,
        cost: mappingToMove.cost,
        count: mappingToMove.count,
        source: 'Штатное расписание'
      }
      
      // Добавляем в основную таблицу
      const updatedRoles = [...this.roles, newRole]
      this.$emit('update:roles', updatedRoles)
      
      // Удаляем из таблицы сопоставления
      const updatedMappings = this.roleMappings.filter((_, i) => i !== index)
      this.$emit('update:roleMappings', updatedMappings)
      
      this.$emit('move-to-main', { mapping: mappingToMove, index })
    }
  }
}
</script>

<style scoped>
/* Стили остаются без изменений */
.modal_main_inputs_head {
  text-align: start;
  margin-bottom: 24px;
  font-size: 18px;
  line-height: 1.4;
  color: #fff;
}

.modal_main_table_content {
  width: 100%;
  overflow-x: auto;
  border: 1px solid #403F6D;
  border-radius: 12px;
  background: #0a0a0f;
}

.table_header {
  background: rgba(64, 63, 109, 0.2);
  border-bottom: 1px solid #403F6D;
  padding: 12px 0;
  font-weight: 600;
}

.table_row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 0.5fr;
  gap: 8px;
  align-items: center;
  padding: 0 12px;
}

.table_row_v2 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 0.5fr;
  gap: 8px;
  align-items: center;
  padding: 0 12px;
}

.table_cell {
  text-align: left;
  padding: 8px 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.source-cell {
  min-width: 100px;
}

.action-cell {
  min-width: 48px;
  display: flex;
  justify-content: center;
}

.table_cell_input {
  display: block;
  padding: 8px 12px;
  background: #ffffff0a;
  border: 1px solid #403F6D;
  border-radius: 8px;
  min-width: 80px;
  cursor: text;
  color: #fff;
  font-size: 14px;
  transition: all 0.3s;
}

.table_cell_input:hover {
  border-color: #8A75FF;
  background: #ffffff15;
}

.table_cell_input:focus {
  outline: none;
  border-color: #8A75FF;
  background: #1a1a2a;
}

.table_cell_class {
  display: inline-block;
  padding: 6px 16px;
  background: #8A75FF33;
  border: 1px solid #8A75FF66;
  border-radius: 20px;
  font-size: 13px;
  color: #fff;
  white-space: nowrap;
}

.table_body .table_row,
.table_body .table_row_v2 {
  border-bottom: 1px solid #403F6D;
  padding: 8px 12px;
}

.table_body .table_row:last-child,
.table_body .table_row_v2:last-child {
  border-bottom: none;
}

.table_add_row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background 0.3s;
  color: #8A75FF;
  font-weight: 500;
  margin-top: 8px;
  border-radius: 8px;
}

.table_add_row:hover {
  background: #8a75ff1a;
}

.table_add_row svg {
  width: 24px;
  height: 24px;
}

.arrow-up-icon {
  transition: transform 0.3s;
}

.arrow-up-icon:hover {
  transform: translateY(-4px);
}

.arrow-up-icon path {
  transition: stroke 0.3s;
}

.arrow-up-icon:hover path {
  stroke: #FF00E1;
}

.modal_main_table_second_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  background: #ffffff0a;
  border: 1px solid #403F6D;
  border-radius: 16px;
}

.modal_main_table_second_content_head {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
}

.modal_main_table_second_content_text {
  font-size: 14px;
  opacity: 0.7;
}

.modal_main_table_second_content_tumbler {
  width: 60px;
  height: 30px;
  background: #ffffff1a;
  border-radius: 30px;
  position: relative;
  cursor: pointer;
  transition: background 0.3s;
  flex-shrink: 0;
}

.modal_main_table_second_content_tumbler_active {
  background: #8A75FF;
}

.modal_main_table_second_content_tumbler_circl {
  width: 26px;
  height: 26px;
  background: white;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: transform 0.3s;
}

.modal_main_table_second_content_tumbler_circl_active {
  transform: translateX(30px);
  background: #4E4199;
}

.modal_main_table_second_content_load_block {
  max-height: 800px;
  transition: max-height 0.5s ease, opacity 0.3s ease;
  overflow: hidden;
}

.modal_main_table_second_content_load_block_hidden {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}

.mapping-table-container {
  margin-top: 16px;
  padding-bottom: 16px;
}

.mapping-table-bottom-spacing {
  height: 16px;
}

.modal_main_load_content_btn {
  display: flex;
  gap: 8px;
  padding: 18px 40px;
  background: #8A75FF;
  justify-content: center;
  border-radius: 24px;
  cursor: pointer;
  transition: opacity 0.3s;
  font-size: 16px;
  font-weight: 500;
  border: none;
  color: white;
}

.modal_main_load_content_btn:hover {
  opacity: 0.9;
}

@media (max-width: 1200px) {
  .table_row {
    grid-template-columns: 1.5fr 1fr 1fr 1fr 0.5fr;
    gap: 4px;
  }
  
  .table_row_v2 {
    grid-template-columns: 1fr 1fr 1fr 1fr 0.5fr;
    gap: 4px;
  }
  
  .table_cell_input {
    min-width: 60px;
    padding: 6px 8px;
    font-size: 13px;
  }
}

@media (max-width: 768px) {
  .table_row,
  .table_row_v2 {
    font-size: 13px;
  }
  
  .table_cell_input {
    min-width: 50px;
    padding: 4px 6px;
  }
  
  .table_cell_class {
    padding: 4px 12px;
    font-size: 12px;
  }
  
  .modal_main_table_second_content {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
  
  .modal_main_table_second_content_tumbler {
    align-self: flex-end;
  }
  
  .table_add_row {
    padding: 12px 16px;
    font-size: 14px;
  }
}

@media (max-width: 580px) {
  .table_row {
    grid-template-columns: 1.2fr 0.8fr 0.8fr 0.8fr 0.3fr;
    gap: 2px;
    padding: 0 4px;
  }
  
  .table_row_v2 {
    grid-template-columns: 1fr 0.8fr 0.8fr 0.8fr 0.3fr;
    gap: 2px;
    padding: 0 4px;
  }
  
  .table_cell {
    padding: 4px 2px;
  }
  
  .table_cell_input {
    min-width: 40px;
    padding: 4px;
    font-size: 12px;
  }
}
.staffing-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  gap: 16px;
  background: #ffffff0a;
  border-radius: 12px;
  border: 1px solid #403F6D;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #403F6D;
  border-top-color: #8A75FF;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>